import React, { useState, useEffect } from 'react'
import Axios from 'axios';
import { host, Host } from '../../App';
const PurchaseForm = () => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  var User = JSON.parse(window.localStorage.getItem("Name"));
  var token = (window.localStorage.getItem("acessToken"));
  const [data, setData] = useState([]);
  const queryParams = {
    token: token,
  };
  const [files, setFiles] = useState([]);


  useEffect(() => {
    Axios.get(`https://` + Host + `/Purchase_Requisitions/alldata`, { params: queryParams })
      .then((data) => {
        setData(data.data);
      })
  }, []);

  const [formData, setFormData] = useState({
    Request_date: date,
    name: User,
    Part_No: "",
    item_description: "",
    brand: "",
    qty: "",
    unit: "",
    vendor: "",
    required_before: date,
    file: null,  // For file upload

    comments: "",
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };
  const uploadFiles = async () => {

    console.log(files.length);
    const data = new FormData();

    data.append("token", token);
    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });

    if (files.length === 0) {
      try {
        Axios.post(`https://` + Host + `/add/withoutfile/Purchase_Requisitions`, data,).then((response) => {
          if (response.status === 200) {
            alert(response.data.message);
            window.location.reload();
          }
        })
          .catch(function (error) {
            console.log(error.response);
          });


      } catch (error) {
        console.error("Upload error:", error.response || error);
      };
    }
    if (files.length > 0) {

      files.forEach((file) => {
        const fileExtension = file.name.split('.').pop(); // Get file extension
        const uniqueFileName = `${Date.now()}.${fileExtension}`; // Create unique file key with extension
        data.append("files", file, uniqueFileName);
        console.log(file);
        console.log(uniqueFileName);
      });
      console.log(data);

      try {
        const response = await Axios.post(`https://` + Host + `/add/Purchase_Requisitions`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status === 200) {
          alert(response.data.message);
          window.location.reload();
        }
      } catch (error) {
        console.error("Upload error:", error.response || error);
      };
    }
  }
  return (
    <div class="Maintenance_request" id="new_purchase_request">
      <table className="table table-bordered" id="Purchase_table">
        <thead>
          <tr>
            <th scope="col" style={{ width: "30%" }}>FIELD</th>
            <th scope="col" style={{ width: "70%" }}>INPUT</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(formData).map(([key, value]) => (
            <tr key={key}>
              <td>{key.replace(/_/g, ' ').toUpperCase()}</td>
              <td>
                {key === "comments" || key === "item_description" ? (
                  <textarea
                    className="form-control"
                    name={key}
                    rows="5"
                    style={{ width: "100%" }}
                    value={value}
                    onChange={handleChange}
                  />
                ) : key === "brand" || key === "vendor" || key === "unit" || key === "Part_No" ? (
                  <>
                    <input
                      type="text"
                      className="form-control"
                      name={key}
                      style={{ width: "100%" }}
                      value={value}
                      onChange={handleChange}
                      list={key} // Attach datalist
                    />
                    <datalist id="brand">
                      <option value="" />
                      {[...new Set(data.map(x => x.Brand))].map((Brand, index) => (
                        <option key={index}>{Brand}</option>
                      ))}
                    </datalist>
                    <datalist id="vendor">
                      <option value="" />
                      {[...new Set(data.map(x => x.Vendor))].map((Vendor, index) => (
                        <option key={index}>{Vendor}</option>
                      ))}
                    </datalist>
                    <datalist id="unit">
                      <option value="" />
                      {[...new Set(data.map(x => x.Unit))].map((Unit, index) => (
                        <option key={index}>{Unit}</option>
                      ))}
                    </datalist>
                    <datalist id="Part_No">
                      <option value="" />
                      {[...new Set(data.map(x => x.Part_No))].map((Part_No, index) => (
                        <option key={index}>{Part_No}</option>
                      ))}
                    </datalist>
                  </>
                ) : key === "file" ? (
                  <input
                    type="file"
                    className="form-control"
                    name={key}
                    style={{ width: "100%" }}
                    multiple
                    onChange={handleFileChange}
                  />
                ) : key === "name" ? (  // Make "name" field readonly
                  <input
                    type="text"
                    className="form-control"
                    name={key}
                    style={{ width: "100%" }}
                    value={value}
                    readOnly
                  />
                ) : (
                  <input
                    type={
                      key.includes("date") ? "date" :
                        key.includes("required_before") ? "date" :
                          key.includes("time") ? "datetime-local" :
                            key === "email" ? "email" : "text"
                    }
                    className="form-control"
                    name={key}
                    style={{ width: "100%" }}
                    value={value}
                    onChange={handleChange}
                  />
                )}
              </td>
            </tr>
          ))}
          <ul>
            {files.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
          <button className="btn btn-primary" onClick={uploadFiles}>Submit</button>
        </tbody>
      </table>

    </div>

  );
};

export default PurchaseForm;